import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { PageData } from '../models/page-data.model';

@Injectable({
  providedIn: 'root'
})
export class PageDataService {
  private readonly endPoint = 'pageData';

  constructor(private api: ApiService) { }

  async getPageData(page: string, section: string) {
    return this.api.promiseGet<PageData>(`${this.endPoint}`, { withCredentials: false, params: { page, section } })
  }
}
